class VariantSelects extends HTMLElement {
  constructor() {
    super()
    this.addEventListener('change', this.onVariantChange)
  }

  onVariantChange() {
    this.updateOptions()
    this.updateMasterId()
    this.toggleAddButton(true, '', false)
    // this.updatePickupAvailability();
    this.removeErrorMessage()

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true)
      this.setUnavailable()
    } else {
      const variantStrings = window.variantStrings || {}
      this.toggleAddButton(
        !this.currentVariant.available,
        variantStrings.soldOut || 'Sold out'
      )
      this.updateURL()
      this.updateVariantInput()
      this.renderProductInfo()
      this.updateShareUrl()
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll('select'),
      (select) => select.value
    )
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option
        })
        .includes(false)
    })
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    )
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`)
    if (!shareButton) return
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    )
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    )
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]')
      input.value = this.currentVariant.id
      input.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability')
    if (!pickUpAvailability) return

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id)
    } else {
      pickUpAvailability.removeAttribute('available')
      pickUpAvailability.innerHTML = ''
    }
  }

  removeErrorMessage() {
    const section = this.closest('section')
    if (!section) return

    const productForm = section.querySelector('product-form')
    if (productForm) productForm.handleErrorMessage()
  }

  renderProductInfo() {
    const variantStrings = window.variantStrings || {}
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')

        const id = `price-${this.dataset.section}`
        const destination = document.getElementById(id)
        const source = html.getElementById(id)
        if (source && destination) destination.innerHTML = source.innerHTML

        const variantTitleId = `variant-title-${this.dataset.section}`
        const variantTitleDest = document.getElementById(variantTitleId)
        const variantTitleSrc = html.getElementById(variantTitleId)
        if (variantTitleSrc && variantTitleDest)
          variantTitleDest.innerHTML = variantTitleSrc.innerHTML

        const price = document.getElementById(`price-${this.dataset.section}`)

        if (price) price.classList.remove('visibility-hidden')
      })
      .catch((error) => {
        console.error('Product info refresh failed:', error)
      })
      .finally(() => {
        this.toggleAddButton(
          !this.currentVariant.available,
          variantStrings.soldOut || 'Sold out'
        )
      })
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    )
    if (!productForm) return
    const addButton = productForm.querySelector('[name="add"]')
    const addButtonText = productForm.querySelector('[name="add"] > span')
    const variantStrings = window.variantStrings || {}

    if (!addButton || !addButtonText) return

    if (disable) {
      addButton.setAttribute('disabled', 'disabled')
      if (text) addButtonText.textContent = text
    } else {
      addButton.removeAttribute('disabled')
      addButtonText.textContent = variantStrings.addToCart || 'Add to cart'
    }

    if (!modifyClass) return
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    )
    if (!button) return
    const addButton = button.querySelector('[name="add"]')
    const addButtonText = button.querySelector('[name="add"] > span')
    const variantStrings = window.variantStrings || {}
    if (!addButton || !addButtonText) return
    addButtonText.textContent = variantStrings.unavailable || 'Unavailable'
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent)
    return this.variantData
  }
}

customElements.define('variant-selects', VariantSelects)

const initHeaderBlendDelay = () => {
  const header = document.querySelector('header[data-header-blend-delay]')
  if (!header) return

  const heroMediaSection = document.querySelector('.hero-media-section')
  const headerHeight = header.offsetHeight || 54
  const blendThreshold = Math.max(0, window.innerHeight - headerHeight)
  const MENU_CLOSE_DELAY = 450 // most of the nav's 600ms collapse transition

  const isMenuOpen = () =>
    !!(
      window.Alpine?.store('menuOpen')?.open ||
      window.Alpine?.store('mobileMenuOpen')?.open
    )

  const toggleBlendMode = () => {
    const shouldApplyBlend =
      isMenuOpen() || !heroMediaSection || window.scrollY >= blendThreshold
    header.classList.toggle('mix-blend-difference', shouldApplyBlend)
  }

  toggleBlendMode()
  window.addEventListener('scroll', toggleBlendMode, { passive: true })
  window.addEventListener('resize', toggleBlendMode)

  // re-run whenever the menu stores change; on close, wait until the nav is mostly collapsed
  let closeTimeout = null
  if (window.Alpine?.effect) {
    window.Alpine.effect(() => {
      void window.Alpine.store('menuOpen')?.open
      void window.Alpine.store('mobileMenuOpen')?.open

      clearTimeout(closeTimeout)
      if (isMenuOpen()) {
        toggleBlendMode()
      } else {
        closeTimeout = setTimeout(toggleBlendMode, MENU_CLOSE_DELAY)
      }
    })
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeaderBlendDelay)
} else {
  initHeaderBlendDelay()
}
